const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速秒播不缓冲',
    desc: '全网CDN加速节点覆盖，智能线路切换技术，无论身处何地都能享受如丝般顺滑的播放体验，告别加载等待。',
    color: 'primary',
  },
  {
    icon: 'ri-4k-line',
    title: '超清画质体验',
    desc: '支持从480P到4K杜比视界的多档画质，热门大片提供HDR高动态范围版本，每一帧都清晰锐利，色彩饱满。',
    color: 'accent',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日海量更新',
    desc: '编辑团队全天候更新，日更新200+部影视内容。电视剧同步播出平台，综艺实时上线，永不错过精彩时刻。',
    color: 'secondary',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备完美适配',
    desc: '响应式设计覆盖手机、平板、电脑，画质自适应网络环境。支持PWA安装，手机桌面一键直达，观影更便捷。',
    color: 'primary',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            平台优势
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            为什么700万影迷选择7777影院
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200 rounded-xl p-6 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                  feature.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : feature.color === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}